import React from "react";
import {
    TextField,
    Button,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    FormControl,
    InputLabel,
    Select,
    OutlinedInput,
    MenuItem
} from '@mui/material';
import EventAdditionalPriceType from '../../../models/EventAdditionalPriceType'
import MasterData from './MasterData'

const PriceTypes = (props: any) => {

    const ColumnNames: string[] = ['ID', 'Bezeichnung', 'Aktiv', 'Aktionen']

    let tableColumns = ColumnNames.map(x => {
        return <TableCell key={x}>{x}</TableCell>
    })

    return (
        <>
            <h2 className='mt-3 title'>Stammdaten - Preistypen</h2>
            <div className='card'>
                <div className='card-header'>
                    <h5>Filters</h5>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <TextField
                                label='Bezeichnung:'
                                name='description'
                                value={props.filter.description}
                                onChange={(e:any) => props.handleFilterChange(e)}
                                fullWidth></TextField>
                        </div>
                    </div>
                    <div className='float-right mt-4'>
                        <Button variant='contained' color='primary' className='btnBlue' onClick={() => props.handleSearch()}>Suchen</Button>
                        <Button
                            className='ml-2 btnBlue'
                            color='primary'
                            variant='contained'
                            onClick={() => props.clearFilters()}
                        >Zurücksetzen</Button>
                    </div>
                </div>
            </div>
            <div className='row mt-3 overflowTable'>
                <Table className="objects-table table">
                    <TableHead>
                        <TableRow>
                            {tableColumns}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.rows}
                    </TableBody>
                </Table>
            </div>
            {
                !props.addNew &&
                <Button
                    className='mt-3 float-right btnBlue'
                    color='primary'
                    variant="contained"
                    onClick={() => {
                        props.changeMode('create')
                        props.showAddNew()
                    }}
                >Hinzufügen</Button>
            }
            {
                props.addNew &&
                <div className='row'>
                    <h4 className='col-sm-12'>Preistype bearbeiten:</h4>
                    <div className='col-sm-12'>
                        <div className='col-sm-6'>
                            <TextField
                                value={props.newObject.priceTypeDescription}
                                name='priceTypeDescription'
                                label='Bezeichnung'
                                onChange={(e:any) => props.handleChangeNewObject(e)}
                                fullWidth />
                        </div>
                        <div className='col-sm-6 mt-3'>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel htmlFor="outlined-aktiv">
                                    Activ
                                </InputLabel>
                                <Select
                                    input={
                                        <OutlinedInput id='outlined-aktiv' fullWidth />
                                    }
                                    name='active'
                                    onChange={(e:any) => props.handleChangeNewObject(e)}
                                    value={props.newObject.active.toString()}
                                    fullWidth
                                >
                                    <MenuItem value={'true'}>Ja</MenuItem>
                                    <MenuItem value={'false'}>Nein</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className='col-sm-4 offset-sm-8'>
                        <Button
                            className='mt-3 float-right btnBlue'
                            color='primary'
                            variant="contained"
                            onClick={() => props.submitNewObject()}>
                            Speichern
                            </Button>
                        <Button
                            className='mt-3 mr-2 float-right btnBlue'
                            color='primary'
                            variant="contained"
                            onClick={() => props.hideAddNew()}>Abbrechen</Button>
                    </div>
                </div>
            }
        </>
    )
}

export default MasterData<EventAdditionalPriceType, keyof EventAdditionalPriceType>(PriceTypes, EventAdditionalPriceType)